export const INFINITE_KEYS_TO_MATCH = [
  'isLoading',
  'isFetching',
  'error',
  'data',
  'queryKey',
  'rawData',
  'isFetchingNextPage',
  'hasNextPage',
];

export const KEYS_TO_MATCH = ['isLoading', 'isFetching', 'error', 'data', 'queryKey', 'rawData'];

export const DATA_SOURCE_RESET_KEYS = [
  'isLoading',
  'isFetching',
  'error',
  'data',
  'rawData',
  'queryKey',
  'isFetchingNextPage',
  'hasNextPage',
  'refetch',
];

export const RAW_RESPONSE_KEY = '$ua_raw_response';
export const TRANSFORMED_RESPONSE_KEY = 'result';
